import _ from 'lodash';
import { getEnvVar } from './env.js';

export const getFileExtension = (filename) => {
  const dotIndex = filename.lastIndexOf('.');
  const ext = filename.substring(dotIndex + 1);
  return ext;
};

export const isValidFileExtension = (filename, supportedFileTypes) => {
  const ext = getFileExtension(filename).toLowerCase();
  const fileType = _.find(supportedFileTypes, { extension: ext });
  return fileType !== undefined;
};

export const getContentType = (filename, supportedFileTypes) => {
  const ext = getFileExtension(filename);
  const fileType = _.find(supportedFileTypes, { extension: ext });
  if (fileType !== undefined) {
    return fileType.contentType;
  }
  return '';
};

export const formatS3FilePath = (filename, folder) => {
  // B3.2 S3→R2: on R2 stages, store the bare public custom-domain URL (served from the bucket root),
  // e.g. https://dev-uploads.bridgebee.app/artwork/z3y_vhAi6.png — decoupled from REGION (now 'auto',
  // for signing only). This URL is also what CF Image Transformations would wrap later (deferred).
  const UPLOAD_PUBLIC_URL = getEnvVar('UPLOAD_PUBLIC_URL');
  if (UPLOAD_PUBLIC_URL) {
    return _.join([UPLOAD_PUBLIC_URL, folder, filename], '/');
  }
  // Legacy S3 stages (not yet cut over): keep the s3.<region>.amazonaws.com/<bucket>/... shape.
  const REGION = getEnvVar('REGION');
  const UPLOAD_BUCKET = getEnvVar('UPLOAD_BUCKET');
  const bucketUrl = _.join(['s3', REGION, 'amazonaws', 'com'], '.');
  return _.join(['https:/', bucketUrl, UPLOAD_BUCKET, folder, filename], '/');
};
